// node_modules
import axios, { AxiosResponse } from "axios";
// Helpers
import { AxiosHelperSingleton } from "Helpers";

export class PartnerController {
    public async getImageAsync(name: string): Promise<string | undefined> {
        try {
            const response: AxiosResponse<{logoUrl: string}> = await axios.get(`${AxiosHelperSingleton.getServerBaseURL()}PartnerLogo/Search?name=${name}`);
            return response.data.logoUrl;
        } catch {
            return undefined;
        }
    }
}

export const PartnerControllerSingleton = new PartnerController();